import { styled as muiStyled } from "@mui/material/styles";
import MuiChip from "@mui/material/Chip";

import { Black, White } from "src/styles/color";
import font from "src/styles/font";

const Chip = muiStyled(MuiChip, {
  shouldForwardProp: (prop) => prop !== "sx",
})((props) => ({
  "& .MuiChip-label": {
    fontSize: font.size.sm,
    fontWeight: 600,
    textTransform: "uppercase",
  },

  "&.MuiChip-filled": {
    "& .MuiChip-label": {
      color: White,
    },
    "& .MuiChip-icon": {
      color: White,
    },
    "&.MuiChip-colorDefault": {
      backgroundColor: "#6A7282",
    },
    "&.MuiChip-colorPrimary": {
      backgroundColor: "#E7000B",
    },
    "&.MuiChip-colorSecondary": {
      backgroundColor: "#9810FA",
    },
    "&.MuiChip-colorInfo": {
      backgroundColor: "#155DFC",
    },
    "&.MuiChip-colorError": {
      backgroundColor: "#C10007",
    },
    "&.MuiChip-colorSuccess": {
      backgroundColor: "#00C950",
    },
    "&.MuiChip-colorWarning": {
      backgroundColor: "#FF6900",
    },
  },

  "&.MuiChip-outlined": {
    "&.MuiChip-colorDefault": {
      border: "1px solid rgba(106, 114, 130, 0.7)",
      color: Black,
    },
    "&.MuiChip-colorPrimary": {
      border: "1px solid rgba(231, 0, 11, 0.7)",
      color: "#E7000B",
    },
    "&.MuiChip-colorSecondary": {
      border: "1px solid rgba(152, 16, 250, 0.7)",
      color: "#9810FA",
    },
    "&.MuiChip-colorInfo": {
      border: "1px solid rgba(21, 93, 252, 0.7)",
      color: "#155DFC",
    },
    "&.MuiChip-colorError": {
      border: "1px solid rgba(193, 0, 7, 0.7)",
      color: "#C10007",
    },
    "&.MuiChip-colorSuccess": {
      border: "1px solid rgba(0, 201, 80, 0.7)",
      color: "#00C950",
    },
    "&.MuiChip-colorWarning": {
      border: "1px solid rgba(255, 105, 0, 0.7)",
      color: "#FF6900",
    },
  },

  "&.MuiChip-secondary": {
    "&.MuiChip-colorDefault": {
      backgroundColor: "#ececec",
      color: "#6a7282",
    },
    "&.MuiChip-colorPrimary": {
      backgroundColor: "#FEF2F2",
      color: "#E7000B",
    },
    "&.MuiChip-colorSecondary": {
      backgroundColor: "#FAF5FF",
      color: "#9810FA",
    },
    "&.MuiChip-colorInfo": {
      backgroundColor: "#EFF6FF",
      color: "#155DFC",
    },
    "&.MuiChip-colorError": {
      backgroundColor: "#FFE2E2",
      color: "#C10007",
    },
    "&.MuiChip-colorSuccess": {
      backgroundColor: "#F0FDF4",
      color: "#00C950",
    },
    "&.MuiChip-colorWarning": {
      backgroundColor: "#FFF7ED",
      color: "#FF6900",
    },
  },
}));

export default Chip;
